export default __webpack_public_path__ + "static/media/settings_ln.41cfb66e.svg";